import * as sso from "../reducers/ssoReducer";
import * as session from "../reducers/sessionReducer";
import * as error from "../reducers/errorReducer";
import * as domain from "../reducers/domainReducer";
import * as localCache from "../reducers/localCacheReducer";
import * as prayerFeature from "../reducers/prayerFeatureReducer";

export const trueInitialState = {
    domain: domain.domainInitialState,
    error: error.errorInitialState,
    session: session.sessionInitialState,
    sso: sso.ssoInitialState,
    localCache: localCache.localCacheInitialState,
    prayerFeature: prayerFeature.prayerFeatureInitialState
};